import React, {useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';

import { createTheme } from "@mui/material";
import Fab from '@mui/material/Fab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const materialTheme = createTheme(({
    // set default for now
}));
  
const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderTop: '2px solid #000', // Add top border here
      borderBottom: '2px solid #000', // Add bottom border here
      padding: theme.spacing(2), // Add some padding to make the border visible
    
    },
    eulaHeader : {
        marginTop: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textDecoration: 'underline',
    },
    eulaNumber :{
        fontWeight: 'bold'
    },
    eulaBody : {
        marginTop: theme.spacing(5),
        textIndent: '1em',
        display: 'flex',
        flexDirection: 'column',
    }
}));

const TermsAndConditions = (props) =>{
    const classes = useStyles();
return(
    <>
    <Fab
        sx={{marginTop:'1.5em', marginLeft:'1.5em'}}
        rel="noopener noreferrer"
        onClick={() => {props.setIsEula(false)}}>
        <ArrowBackIcon/>
    </Fab>
    <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Typography component="h1" variant="h5" className={classes.paper}>
            Terms and Conditions 
        </Typography>
        
        <Typography component="h2" variant="body1" className={classes.eulaHeader}>
            END USER LICENSE AGREEMENT
        </Typography>
        
        <Typography component="h2" variant="body1" className={classes.eulaBody}>
            This End User License Agreement ("Agreement") is a legal agreement between you ("you" or "End User") and Coraggio Corp., a Philippine corporation, with regards to your use of Transacti.com, a distributor/wholesaler transaction automation system designed to automate distributor inventory management and record distributor sales to trade transaction information (the "Software"). By accessing or using the Software, you acknowledge that you have read, understood, and agree to be bound by the terms of this Agreement. If you do not agree to the terms of this Agreement, do not access or use the Software.
        </Typography>

        <Typography  mt={1} component="h2" variant="body1">

            <ol>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        License Grant. 
                    </Typography>
                    <Typography>
                        Coraggio Corp. grants you a non-exclusive, non-transferable, limited license to use the Software for your internal business purposes, subject to the terms and conditions of this Agreement.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Ownership. 
                    </Typography>
                    <Typography>
                        The Software and all intellectual property rights therein, including without limitation all copyrights, trademarks, and trade secrets, are and will remain the sole and exclusive property of Coraggio Corp. and its licensors. You acknowledge and agree that you have no ownership rights in the Software and that this Agreement does not convey any ownership rights to you.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        User Conduct
                    </Typography>
                    <Typography>
                        You agree to use Transacti.com only for lawful purposes and in a manner that does not violate the rights of, or restrict or inhibit the use and enjoyment of Transacti.com by any third party. You may not use Transacti.com to transmit or post any unlawful, threatening, defamatory, obscene, or indecent material, or any material that could constitute or encourage conduct that would be considered a criminal offense, give rise to civil liability, or otherwise violate any law.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Restrictions on Use. 
                    </Typography>
                    <Typography>
                        You may not:
                        <ol type="a">
                            <li>sell, lease, license, sublicense, distribute, or otherwise transfer the Software or any part thereof to any third party;</li>
                            <li>modify, adapt, alter, translate, or create derivative works based on the Software;</li>
                            <li>reverse engineer, decompile, disassemble, or otherwise attempt to derive the source code or underlying ideas or algorithms of the Software;</li>
                            <li>remove or alter any proprietary notices or labels on the Software; or</li>
                            <li>use the Software for any purpose other than as authorized by this Agreement.</li>
                        </ol>
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Maintenance and Support.
                    </Typography>
                    <Typography>
                        Coraggio Corp. has no obligation to provide maintenance or support for the Software. However, if Coraggio Corp. elects to provide any updates, upgrades, or new versions of the Software, such updates, upgrades, or new versions will be subject to the terms and conditions of this Agreement.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Termination. 
                    </Typography>
                    <Typography>
                        Coraggio Corp. has no obligation to provide maintenance or support for the Software. However, if Coraggio Corp. elects to provide any updates, upgrades, or new versions of the Software, such updates, upgrades, or new versions will be subject to the terms and conditions of this Agreement.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Disclaimer of Warranty.
                    </Typography>
                    <Typography>
                        The software is provided "as is" and without warranty of any kind. To the maximum extent permitted by applicable law, Coraggio Corp. And its licensors disclaim all warranties, either express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, and noninfringement with respect to the software.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Limitation of Liability. 
                    </Typography>
                    <Typography>
                    To the maximum extent permitted by applicable law, in no event will Coraggio Corp. or its licensors be liable for any indirect, special, incidental, or consequential damages (including lost profits) arising out of the use or inability to use the software, even if Coraggio Corp. has been advised of the possibility of such damages. In no event shall Coraggio Corp.'s liability to you exceed the amount paid by you for the software.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Indemnification 
                    </Typography>
                    <Typography>
                        You agree to indemnify and hold Coraggio Corp. and its affiliates, officers, agents, and employees harmless from any claim or demand, including reasonable attorneys' fees, made by any third party due to or arising out of your use of Transacti.com, your violation of this Agreement, or your violation of any rights of another.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Data Privacy.
                    </Typography>
                    <Typography>
                        Data Privacy. You acknowledge and agree that the Software may collect, use, and store certain data and information related to your use of the Software, including without limitation your IP address, device information, and usage statistics. You further acknowledge and agree that this data may be transferred to and stored on servers located outside the Philippines and may be subject to the laws and regulations of the country in which the servers are located.
                    </Typography>
                </li>
                <li>
                    <Typography mt={3} component="h2" variant="body1">
                        Coraggio Corp. will handle and protect your data in accordance with the Philippine Data Privacy Act of 2012 and its Implementing Rules and Regulations, including without limitation the following provisions:
                        <ol type="a">
                            <li>Collection of personal data will be for lawful purposes, and the personal data collected will be relevant, necessary, and proportional to the purposes for which they are collected.</li>
                            <li>Coraggio Corp. will obtain your consent prior to collecting, using, or disclosing your personal data.</li>
                            <li>Coraggio Corp. will implement appropriate measures to protect the security and confidentiality of your personal data.</li>
                            <li>You have the right to access, correct, and object to the processing of your personal data.</li>
                        </ol>
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Indemnification  
                    </Typography>
                    <Typography>
                        <ol type="a">
                            <li>You agree to indemnify and hold Coraggio Corp. and its affiliates, officers, agents, and employees harmless from any claim or demand, including reasonable attorneys' fees, made by any third party due to or arising out of your use of Transacti.com, your violation of this Agreement, or your violation of any rights of another.</li>
                        </ol>
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Governing Law and Dispute Resolution. 
                    </Typography>
                    <Typography>
                    This Agreement and your use of the Software will be governed by and construed in accordance with the laws of the Philippines, without giving effect to any principles of conflicts of law. Any disputes arising out of or in connection with this Agreement will be resolved through amicable negotiation. If the parties are unable to reach a resolution through negotiation, the dispute will be finally settled by arbitration in accordance with the Rules of the Philippine Dispute Resolution Center, Inc. The arbitration will be conducted in Quezon City, Philippines and the language of the arbitration will be English. The decision of the arbitrator will be final and binding on the parties.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Entire Agreement. 
                    </Typography>
                    <Typography>
                    This Agreement constitutes the entire agreement between you and Coraggio Corp. with respect to the Software and supersedes all prior or contemporaneous communications and proposals, whether oral or written. This Agreement may not be amended or modified except in writing signed by both parties.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Waiver and Severability
                    </Typography>
                    <Typography>
                        The failure of either party to exercise any right or remedy under this Agreement will not constitute a waiver of such right or remedy. If any provision of this Agreement is found to be invalid or unenforceable, the remaining provisions will remain in full force and effect.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Assignment. 
                    </Typography>
                    <Typography>
                        You may not assign or transfer this Agreement or your rights or obligations under this Agreement without the prior written consent of Coraggio Corp. Coraggio Corp. may assign or transfer this Agreement or its rights or obligations under this Agreement without your consent.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    No Third-Party Beneficiaries.
                    </Typography>
                    <Typography>
                    This Agreement is for the benefit of the parties only and is not intended to create any rights or remedies in favor of any third party.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Survival
                    </Typography>
                    <Typography>
                    The provisions of this Agreement relating to ownership, data privacy, disclaimer of warranty, limitation of liability, governing law and dispute resolution, entire agreement, waiver and severability, and survival will survive the termination of this Agreement
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Contact Information. 
                    </Typography>
                    <Typography>
                    If you have any questions or concerns about this Agreement or the Software, please contact Coraggio Corp. at the following address:
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} >
                    Coraggio Corp. Attn: Legal Department: legal@Coraggio.com
                    </Typography>
                </li>
                <li>
                    <Typography mt={3} >
                    Acceptance of Agreement. By accessing or using the Software, you acknowledge that you have read, understood, and agree to be bound by the terms of this Agreement. If you do not agree to the terms of this Agreement, do not access or use the Software

                    </Typography>
                </li>
            </ol>
            
        </Typography>


        <Typography  mt={3} component="h2" variant="body1" className={classes.eulaHeader}>
            DATA PRIVACY POLICY
        </Typography>

        <Typography component="h2" variant="body1" className={classes.eulaBody}>
            This data privacy policy ("Policy") describes how Coraggio Corp. ("we," "us," or "our") collects, uses, and protects the personal data of users of Transacti.com, a distributor/wholesaler transaction automation system designed to automate distributor inventory management and record distributor sales to trade transaction information (the "Service").
            By using the Service, you acknowledge that you have read, understood, and agree to the collection, use, and disclosure of your personal data as described in this Policy. If you do not agree with our policies and practices, do not use the Service.
        </Typography> 
        <Typography  mt={1} component="h2" variant="body1">
            <ol>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                        Personal Data We Collect 
                    </Typography>
                    <Typography>
                        We collect personal data when you use the Service, including but not limited to:

                        <ol type="a">
                            <li>Contact information, such as your name, email address, and phone number;</li>
                            <li>Account information, such as your username and password;</li>
                            <li>Transaction information, such as your purchase history and payment details;</li>
                            <li>Device information, such as your IP address, device type, and operating system;</li>
                            <li>Usage data, such as your browsing history, search queries, and the pages you access on the Service; and</li>
                            <li>Any other personal data that you voluntarily provide to us.</li>
                        </ol>
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    How We Use Your Personal Data
                    </Typography>
                    <Typography>
                    We use your personal data for the following purposes:


                        <ol type="a">
                            <li> To provide, maintain, and improve the Service;</li>
                            <li>To process and fulfill your transactions and requests;</li>
                            <li>To communicate with you about your account, the Service, and other matters;</li>
                            <li>To personalize your experience on the Service and show you content that is relevant to your interests;</li>
                            <li>To analyze and understand how the Service is used, and to improve and develop new features and functionality;</li>
                            <li>To detect, prevent, and investigate fraud, unauthorized access, and other illegal activities; and</li>
                            <li>As otherwise required or permitted by law.</li>
                        </ol>
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Sharing of Personal Data
                    </Typography>
                    <Typography>
                    We may share your personal data with the following parties:


                        <ol type="a">
                            <li>Our affiliates, subsidiaries, and parent company;</li>
                            <li> Service providers, such as payment processors and hosting companies, who assist us in operating the Service;</li>
                            <li>Law enforcement agencies, government authorities, or other third parties when we are required or permitted to do so by law, or when such disclosure is necessary to protect our rights or the safety of our users; and</li>
                            <li>Any other party to whom you explicitly authorize us to share your personal data.</li>
                        </ol>
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Data Transfer and Storage
                    </Typography>
                    <Typography>
                    Your personal data may be transferred to, and stored and processed in, countries other than the Philippines. These countries may have data protection laws that are different from the laws of the Philippines.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Data Retention
                    </Typography>
                    <Typography>
                    We have implemented appropriate technical and organizational measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet, or method of electronic storage, is completely secure. Therefore, we cannot guarantee the absolute security of your personal data.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Data Security
                    </Typography>
                    <Typography>
                    We will retain your personal data for as long as necessary to fulfill the purposes for which it was collected, or as required by law.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Your Rights
                    </Typography>
                    <Typography>
                        You have the following rights with respect to your personal data:

                        <ol type="a">
                            <li> Right of access: You have the right to request a copy of the personal data that we hold about you, as well as information about how we use and process your personal data</li>
                            <li> Right of correction: If you believe that any personal data we hold about you is incorrect or incomplete, you have the right to request that we correct or update your personal data.</li>
                            <li>Right of erasure: You have the right to request that we erase your personal data, subject to certain exceptions prescribed by law.</li>
                            <li>Right of restriction: You have the right to request that we restrict the processing of your personal data, such as by suspending the use of your personal data while we verify its accuracy.</li>
                            <li>Right of data portability: You have the right to request that we transfer your personal data to another organization, or to you, in a structured, commonly used, and machine-readable format.</li>
                            <li>Right of objection: You have the right to object to the processing of your personal data, including for the purpose of direct marketing.</li>
                            <li> Right to withdraw consent: If we rely on your consent to process your personal data, you have the right to withdraw your consent at any time.</li>
                        </ol>
                    </Typography>
                    
                    <Typography  mt={3}>
                    To exercise any of these rights, please contact us using the contact information provided in section 10 below. We may ask you to provide additional information to verify your identity and to assist us in fulfilling your request.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Changes to This Policy
                    </Typography>
                    <Typography>
                        We may update this Policy from time to time to reflect changes in our practices or to comply with legal requirements. We will post any updates on this page and encourage you to review this Policy periodically. Your continued use of the Service after any changes have been made will constitute your acceptance of such changes.
                    </Typography>
                </li>
                <li>
                    <Typography  mt={3} component="h2" variant="body1" className={classes.eulaNumber}>
                    Contact Us
                    </Typography>
                    <Typography>
                    If you have any questions or concerns about this Policy or our handling of your personal data, please contact us at the following address:Coraggio Corp. Attn: Legal Department 
                    </Typography>
                </li>
            </ol>
        </Typography>
        </Container>
    </>


)
}

export default TermsAndConditions;